<template>
  <el-dialog
    id="user-popup"
    title
    :visible.sync="modelValue"
    width="408px"
    :before-close="handleClose"
  >
    <h3 class="popup-text">修改密码</h3>
    <div class="popup-list">
      <div class="popup-item">
        <span class="popup-item-name">旧密码</span>
        <div class="popup-content">
          <el-input
            class="popup-item-input"
            type="password"
            v-model="oldPassword"
            placeholder="请输入旧密码"
          ></el-input>
        </div>
      </div>
      <span class="show-tip" v-if="showOldTip">密码错误</span>
      <div class="popup-item">
        <span class="popup-item-name">新密码</span>
        <div class="popup-content">
          <el-input
            class="popup-item-input"
            type="password"
            v-model="newPassword"
            @blur="handleCheckoutNew"
            placeholder="请输入由字母或数字组成的6-16位密码"
          ></el-input>
        </div>
      </div>
      <span class="show-tip" v-if="showNewTip"
        >密码应由6-16位字母或数字组成</span
      >
      <div class="popup-item">
        <span class="popup-item-name">确认密码</span>
        <div class="popup-content">
          <el-input
            class="popup-item-input"
            type="password"
            v-model="againPassword"
            @blur="handleCheckoutAgain"
            placeholder="请输入新密码"
          ></el-input>
        </div>
      </div>
      <span class="show-tip" v-if="showAgainTip">两次密码输入不符</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="handleConfirm"
        class="confirm-button"
        :class="
          oldPassword &&
          newPassword &&
          againPassword &&
          !showAgainTip &&
          !showNewTip &&
          !showOldTip
            ? 'isActive'
            : ''
        "
        >确定</el-button
      >
      <el-button @click="handleCancel">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { modelMixin } from '../../assets/js/mixins/model';
import { regEpxUserPassword } from '../../config/regEpx';
import { modifyPassword } from '../../api/index';
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'UserPopup',
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      againPassword: '',
      showNewTip: false, //显示提示信息
      showAgainTip: false,
      showOldTip: false
    };
  },
  mixins: [modelMixin],
  computed: {
    ...mapGetters('login', ['userInfo', 'authToken'])
  },
  methods: {
    ...mapMutations('login', ['setUserInfo', 'setAuthToken']),
    /**
     * 检测新密码格式回调
     */
    handleCheckoutNew() {
      this.showNewTip = regEpxUserPassword(this.newPassword);
    },
    /**
     * 检测确认密码回调
     */
    handleCheckoutAgain() {
      this.showAgainTip = this.newPassword == this.againPassword ? false : true;
    },
    /**
     * 确认修改密码回调
     */
    handleConfirm(newPassword, oldPassword, userUid) {
      if (this.oldPassword && !this.showAgainTip && !this.showNewTip) {
        modifyPassword({
          newPassword: this.newPassword,
          oldPassword: this.oldPassword,
          userUid: this.userInfo.uid
        }).then(res => {
          if (res.data.code == 200) {
            this.setUserInfo('');
            this.setAuthToken('');
            this.modelValue = false;
            this.showOldTip = false;
            this.$prompt('修改成功');
            this.$router.push({ name: 'Login' });
          } else {
            this.showOldTip = true;
          }
        });
      }
    },
    /**
     * 取消修改密码回调
     */
    handleCancel() {
      this.oldPassword = '';
      this.newPassword = '';
      this.againPassword = '';
      this.showOldTip = false;
      this.showNewTip = false;
      this.showAgainTip = false;
      this.modelValue = false;
    },
    handleClose(done) {
      this.oldPassword = '';
      this.newPassword = '';
      this.againPassword = '';
      this.showOldTip = false;
      this.showNewTip = false;
      this.showAgainTip = false;
      this.modelValue = false;
      done();
    }
  }
};
</script>

<style lang="scss">
#user-popup {
  .popup-list {
    .show-tip {
      font-size: 12px;
      color: red;
      margin-left: 95px;
    }
    .popup-item {
      box-sizing: content-box;
      display: flex;
      justify-content: space-around;
      padding: 6px 0;
      height: 30px;
      line-height: 30px;
      width: 400px;
      &-name {
        color: $color-primary;
        display: block;
        width: 56px;
      }
      .popup-content {
        display: flex;
        justify-content: flex-start;
        width: 300px;
        .el-input {
          width: 250px !important;
          height: 28px;
          &__inner {
            padding-left: 5px !important ;
            border-radius: 2px;
            width: 250px;
            height: 28px;
            font-size: 10px;
            &:focus {
              border-color: $color-border-light;
            }
          }
        }
      }
    }
  }
  .el-dialog__header {
    padding: 0px;
  }
  .popup-text {
    height: 30px;
    width: 369px;
    font-size: 16px;
    margin-bottom: 30px;
    border-bottom: 1px solid $color-border-light;
  }
  .isActive {
    background-color: $color-primary;
    color: #fff;
  }
  .el-button {
    border: 0px;
    width: 68px;
    height: 30px;
  }
  .confirm-button {
    border: 1px solid $color-border-light;
  }
}
</style>
